import React from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '../components/AuthBridge';
import { ShieldAlert, ArrowLeft, Home, Microscope, Database, HelpCircle } from 'lucide-react';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const { user, activeCert } = useAuth();

  const handleReturn = () => {
    const targetCert = activeCert?.id || user?.activeCertId || 'cna';
    navigate(`/${targetCert}/dashboard`);
  };

  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center py-8 sm:py-12 animate-fade-in text-slate-900 dark:text-slate-100">
      <div className="max-w-xl w-full text-center space-y-10">
        <div className="relative inline-block">
          <div className="w-24 h-24 md:w-32 md:h-32 bg-rose-50 rounded-[2.5rem] flex items-center justify-center mx-auto shadow-xl border border-rose-100 relative z-10">
            <ShieldAlert size={56} className="text-rose-500 animate-pulse" />
          </div>
          <div className="absolute -top-4 -right-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center border border-slate-100 z-20">
            <HelpCircle size={24} className="text-slate-300" />
          </div>
          <div className="absolute inset-0 bg-rose-500/10 blur-3xl rounded-full scale-150"></div>
        </div>

        <div className="space-y-4">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-slate-900 text-white rounded-full text-[10px] font-black uppercase tracking-widest shadow-lg">
            <Database size={12} className="text-rose-400" /> Registry Error 404
          </div>
          <h1 className="text-3xl md:text-5xl font-black uppercase tracking-tighter leading-none text-slate-900">
            Namespace Not Found
          </h1>
          <p className="text-slate-500 font-medium text-sm md:text-lg leading-relaxed italic max-w-md mx-auto">
            "The requested certification path does not exist in the clinical registry. Verify the URL identifier or return to Mission Control."
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <button 
            onClick={handleReturn}
            className="flex items-center justify-center gap-3 px-8 py-4 bg-slate-900 text-white rounded-2xl font-black text-xs uppercase tracking-widest hover:bg-black transition-all shadow-xl active:scale-95 border-b-4 border-black"
          >
            <Home size={18} /> Mission Control
          </button>
          <button 
            onClick={() => navigate(-1)}
            className="flex items-center justify-center gap-3 px-8 py-4 bg-white text-slate-600 rounded-2xl font-black text-xs uppercase tracking-widest border border-slate-200 hover:bg-slate-50 transition-all shadow-sm active:scale-95"
          >
            <ArrowLeft size={18} /> Previous Phase
          </button>
        </div>

        <div className="pt-10 border-t border-slate-100 flex items-center justify-center gap-8 opacity-30 grayscale">
            <div className="flex items-center gap-2">
                <Microscope size={14}/>
                <span className="text-[9px] font-black uppercase tracking-widest text-slate-500">Diagnostic Integrity</span>
            </div>
            <div className="flex items-center gap-2">
                <Database size={14}/>
                <span className="text-[9px] font-black uppercase tracking-widest text-slate-500">Logic Partitioned</span>
            </div>
        </div>
      </div>
    </div>
  );
};